import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getOutgoingVehicleBulkSelection } from '../../../reducers/compoundManagementSlice';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { useGetOutgoingVehicleIdsMutation } from '../../../api/compoundManagementApi';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { FIXED_OUTGOING_CACHE_KEY } from './OutgoingVehicleBulkSelectionDropdown';

export const OUTGOING_CONTENT_LOADER_TEST_ID = 'outgoing-selection-cell-loader';

type SelectionCellProps = {
    vehicleId: string;
};

export const OutgoingSelectionCell = ({ vehicleId }: SelectionCellProps) => {
    const isSelected = useAppSelector((state) => getOutgoingVehicleBulkSelection(state).includes(vehicleId));
    const dispatch = useAppDispatch();
    const [, { isLoading }] = useGetOutgoingVehicleIdsMutation({ fixedCacheKey: FIXED_OUTGOING_CACHE_KEY });

    const onSelect = () => {
        if (isSelected) {
            dispatch(compoundManagementSlice.actions.removeFromOutgoingBulkSelection([vehicleId]));
        } else {
            dispatch(compoundManagementSlice.actions.addToOutgoingBulkSelection([vehicleId]));
        }
    };

    const ariaLabel = isSelected ? 'Remove vehicle from selection' : 'Add vehicle to selection';

    return (
        <td className="table-checkbox">
            {isLoading ? (
                <ContentLoader data-testid={OUTGOING_CONTENT_LOADER_TEST_ID} />
            ) : (
                <Checkbox onChange={onSelect} checked={isSelected} aria-label={ariaLabel} />
            )}
        </td>
    );
};
